import Vue from 'vue';

export const FocusField = {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
}

Vue.directive('focus', FocusField)